import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { LocalizationModule } from "../Global/LocalizationModule";
import { LessonFilter } from "./LessonFilter";
import { PriceHelper } from "../../Lib/Helper/PriceHelper";
import { AxModal } from "@axess/limestone"
import { ProductTriple } from "../../Models/Products/ProductTriple";
import { ILessonPackageSelectionInit } from "./Selection";
import { AxCounter } from '../../Limestone/AxCounter/AxCounter';
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

export class SelectionAddSlot {
    constructor(private _priceHelper = new PriceHelper(null, false),
        private _requestHelper = new RequestHelper(),
        private _i18nHelper = new I18nHelper,
        private _axLimestone = new AxLimeStone(),
        private _axLoading = new AxLoading()) { }

    localizationModule: LocalizationModule;
    pTypeSelectionModal: AxModal;
    summaryListModal: AxModal;
    lessonFilter: LessonFilter;
    initData: ILessonPackageSelectionInit;

    counterArr: AxCounter[] = [];

    displayedResult: ISelectionSlotResult;
    currentAvailableSlots: number = 0;

    cart: SelectionCart[] = [];

    init(lessonFilter: LessonFilter, init: ILessonPackageSelectionInit) {
        this.lessonFilter = lessonFilter;
        this.initData = init;
        this.localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');

        this.pTypeSelectionModal = new AxModal();
        this.pTypeSelectionModal.init({
            selector: '.lessonPackage_filter_level-drpdn'
        });

        this.summaryListModal = new AxModal();
        this.summaryListModal.init({
            selector: '[data-display-lp-summary="expand"]'
        });
        this.initCounter();
        this.checkQuantity();


        $('[data-trigger-lp="addSlot"]').on('click',
            () => {
                this.addToTmpCart();
                this.pTypeSelectionModal.close($('#lessonPackage_selection_pType-modal')[0]);
            });

        $('[data-trigger-lp="editSlot"]').on('click',
            () => {
                this.editToTmpCart();
                this.pTypeSelectionModal.close($('#lessonPackage_selection_pType-modal')[0]);
            });

        //$('[data-display-lp-summary="expand"]').on('click',
        //    () => {
        //        $('[data-display-lp-summary="detail"]').toggleClass('d-none');
        //        $('[data-display-lp-summary="expand"] i').toggleClass('la-angle-up la-angle-down');
        //    });


        $('[data-display-lp-summary="slotList"]').on('click',
            "button[data-lessonwebnr][data-arc][data-lessondefnr][data-lessonnr]",
            (e) => {
                this.summaryListModal.close(document.getElementById(`lessonPackage_summaryList-modal`));
                this.loadSlotList(e.currentTarget, $(e.currentTarget).attr('data-date')).then(x => {
                    this.setEditStateToModal();
                });
            });

        $('[data-display-lp-summary="submit"]').on('click',
            () => {
                const dataToSend = this.cart.map(x => {
                    return x.packages.filter(y => y.quantity > 0).map((y) => {
                        return {
                            ...y,
                            ...{
                                from: x.from,
                                to: x.to,
                                lessonNr: x.lessonNr,
                                lessonWebNr: x.lessonWebNr,
                                lessonArcNr: x.arcNr,
                                lessonDefNr: x.lessonDefNr,
                                lessonPackagePositionNr: y.packagePosNr
                            }
                        }
                    });
                }).reduce((pre, cur) => {
                    return pre.concat(cur);
                }).map(y => {
                    return {
                        ...y.productTriple,
                        ...{
                            quantity: y.quantity,
                            from: y.from,
                            to: y.to,
                            lessonNr: y.lessonNr,
                            lessonWebNr: y.lessonWebNr,
                            lessonArcNr: y.lessonArcNr,
                            lessonDefNr: y.lessonDefNr,
                            lessonPackagePositionNr: y.lessonPackagePositionNr
                        }
                    }
                });

                const queryString = this._requestHelper.base64UrlSave(dataToSend);

                window.location.href = `${this.initData.submitUrl}?r=${queryString}`;
                //this._requestHelper.postToUrl(this.initData.submitUrl, dataToSend);
            });
    }

    initListEvents(parent: HTMLElement) {
        $(parent).find('button[data-lessonwebnr][data-arc][data-lessondefnr][data-lessonnr]').on('click', (e) => {
            const $parent = $(parent);
            this.loadSlotList(e.delegateTarget, $parent.attr('data-date')).then(x => {
                let currentLesson = this.getCurrentLesson();

                if (currentLesson == null) {
                    this.setAddStateToModal();
                } else {
                    this.setEditStateToModal();
                }
            });
        });
    }

    setAddStateToModal() {
        $('[data-display-lp-add="edit"]').toggleClass('d-none', true);
        $('[data-display-lp-add="add"]').toggleClass('d-none', false);
        this._axLoading.HideLoadingIndicator($('#lessonPackage_selection_pType-modal')[0]);
        $('#lessonPackage_selection_pType-modal .ax-modal-dialog').removeClass('d-none');
    }

    setEditStateToModal() {
        const existingCart = this.getCurrentLesson();

        for (let pack of existingCart.packages) {
            this.counterArr[pack.personTypeLink].setValue(pack.quantity);
        }
        this.checkQuantity();
        this.updatePrice();
        $('[data-display-lp-add="edit"]').toggleClass('d-none', false);
        $('[data-display-lp-add="add"]').toggleClass('d-none', true);

        this._axLoading.HideLoadingIndicator($('#lessonPackage_selection_pType-modal')[0]);
        $('#lessonPackage_selection_pType-modal .ax-modal-dialog').removeClass('d-none');
    }

    initCounter() {
        for (let pType of this.initData.filterData.pTypes) {
            const tmpCounter = new AxCounter();
            tmpCounter.Init({
                Selector: `[data-display-lp-pType=${pType.id}]`,
                Value: 0,
                Min: 0
            });
            this.counterArr[pType.id] = tmpCounter;
            tmpCounter.Subscribe(n => {
                this.checkQuantity();
                this.updatePrice();
                this.updateCounter();
            });
        }
    }

    loadSlotList(e: HTMLElement, date: string): Promise<ISelectionSlotResult> {
        const $target = $(e);
        const arcNr = $target.data('arc');
        const lessonWebNr = $target.data('lessonwebnr');
        const lessonDefNr = $target.data('lessondefnr');
        const lessonNr = $target.data('lessonnr');
        const locationId = $target.data('location');
        const levelNr = $target.data('level');

        return new Promise<ISelectionSlotResult>((resolve) => {
            $('#lessonPackage_selection_pType-modal .ax-modal-dialog').addClass('d-none');
            this.pTypeSelectionModal.open($('#lessonPackage_selection_pType-modal')[0]);
            this._axLoading.ShowLoadingIndicator($('#lessonPackage_selection_pType-modal')[0], true);

            AxessViewer.loadPartialView('/LessonPackage/_SelectionSlot',
                {
                    arcNr: arcNr,
                    lessonWebNr: lessonWebNr,
                    lessonDefNr: lessonDefNr,
                    lessonNr: lessonNr,
                    date: date
                },
                (resp: ISelectionSlotResult) => {
                    resp.locationId = locationId;
                    resp.lessonLevelNr = levelNr;
                    this.displayedResult = resp;
                    this.currentAvailableSlots = resp.availableSlots;

                    this.resetQuantity();
                    this.updateCounter();

                    //$('[data-display-lp=available]').html(this._i18nHelper.GetTranslation(Translations.SlotsAvailable, resp.availableSlots.toString()));
                    $('[data-display-lp=name]').html(resp.name);

                    const from = moment(resp.from, 'YYYY-MM-DD HH:mm:ss');
                    const to = moment(resp.to, 'YYYY-MM-DD HH:mm:ss');

                    $('[data-display-lp=date]')
                        .html(`${from.format(this.initData.filterData.datePattern)}, ${from.format('LT')}-${to.format('LT')}`);


                    $('[data-display-lp=description]')
                        .toggleClass('d-none', resp.description == null || resp.description == '');
                    $('[data-display-lp=description]').html(resp.description);


                    $('[data-display-lp-pType]').addClass('d-none');

                    for (const pack of resp.packages) {
                        $(`[data-display-lp-pType="${pack.personTypeLink}"]`).removeClass('d-none');
                    }
                    resolve(resp);
                },
                {});
        });
    }


    renderCartList() {
        $(`[data-display-lp-summary="slotList"]`).html('');
        for (let entry of this.cart) {
            const $template = $('[data-display-lp="slotTemplate"]').clone();
            const location = this.initData.locations.find(x => x.locationId === entry.locationId);
            const level = this.initData.levels.find(x => x.lessonLevelNr === entry.lessonLevelNr);

            const from = moment(entry.from, 'YYYY-MM-DD HH:mm:ss');
            const to = moment(entry.to, 'YYYY-MM-DD HH:mm:ss');

            $template.removeAttr('data-display-lp');
            $template.find('[data-display-lp-slotTemplate="name"]').html(`${typeof level?.name != 'undefined' ? `${level?.name}: ` : ""} ${entry.name}`);
            $template.css('background-color', level?.backgroundColor);
            $template.css('border-color', level?.borderColor);

            $template.find('[data-display-lp-slotTemplate="icon"]').css('background-image', `url('${level?.iconPath}')`);


            const quantity = entry.packages.reduce((n, { quantity }) => n + quantity, 0);
            $template.find('[data-display-lp-slotTemplate="quantity"]').html(quantity.toString());
            $template.find('[data-display-lp-slotTemplate="price"]').html(this._priceHelper.GetPriceStringWithCurrencySymbol(this._priceHelper.GetPrice(entry.packages[0].price)));

            $template.find('[data-display-lp-slotTemplate="quantity"]').html(quantity.toString());

            $template.attr('data-lessonWebNr', entry.lessonWebNr);
            $template.attr('data-lessonWebNr', entry.lessonWebNr);
            $template.attr('data-arc', entry.arcNr);
            $template.attr('data-lessonDefNr', entry.lessonDefNr);
            $template.attr('data-lessonNr', entry.lessonNr);
            $template.attr('data-location', entry.locationId);
            $template.attr('data-level', entry.lessonLevelNr);
            $template.attr('data-date', from.format('YYYY-MM-DD'));

            $template.find('[data-display-lp-slotTemplate="info"]').html(`${from.format('DD MMMM, LT').replace(`:00`, '')}-${to.format('LT').replace(`:00`, '')} • ${location.locationName}`);

            $(`[data-display-lp-summary="slotList"]`).append($template);
        }

        this.markSelectedSlots();
    }

    markSelectedSlots() {
        $('button[data-lessonwebnr][data-arc][data-lessondefnr][data-lessonnr]').removeClass('ax-border-primary');

        for (let entry of this.cart) {
            const from = moment(entry.from, 'YYYY-MM-DD HH:mm:ss');

            const $lessonButton = $(`.calendar-body[data-date=${from.format('YYYY-MM-DD')}] button[data-lessonwebnr=${entry.lessonWebNr
                }][data-arc=${entry.arcNr}][data-lessondefnr=${entry.lessonDefNr}][data-lessonnr=${entry.lessonNr}]`);

            if ($lessonButton.length > 0) {
                $lessonButton.addClass('ax-border-primary');
            }
        }
    }

    editToTmpCart() {
        const existingCart = this.getCurrentLesson();

        for (let pack of this.displayedResult.packages) {
            const quantity = this.counterArr[pack.personTypeLink].GetValue();
            let existingEntry = existingCart.packages.find(x => x.personTypeLink === pack.personTypeLink);

            if (existingEntry != null) {
                existingEntry.quantity = quantity;
            } else {
                existingCart.packages.push({
                    name: pack.name,
                    price: pack.price,
                    personTypeLink: pack.personTypeLink,
                    productTriple: pack.productTriple,
                    quantity: quantity,
                    packagePosNr: pack.packagePosNr
                });
            }
        }
        this.updateSummary();
    }

    addToTmpCart() {
        let quantities: { id: number; quantity: number; }[] = [];

        const existingCart = this.getCurrentLesson();

        if (existingCart != null) {
            for (let pack of this.displayedResult.packages) {
                const quantity = this.counterArr[pack.personTypeLink].GetValue();
                if (quantity === 0) continue;

                let existingEntry = existingCart.packages.find(x => x.personTypeLink === pack.personTypeLink);

                if (existingEntry != null) {
                    existingEntry.quantity += quantity;
                } else {
                    existingCart.packages.push({
                        name: pack.name,
                        price: pack.price,
                        personTypeLink: pack.personTypeLink,
                        productTriple: pack.productTriple,
                        quantity: quantity,
                        packagePosNr: pack.packagePosNr
                    });
                }
            }
        } else {
            for (let pack of this.displayedResult.packages) {
                const quantity = this.counterArr[pack.personTypeLink].GetValue();
                if (quantity === 0) continue;


                quantities.push({ id: pack.personTypeLink, quantity: quantity });
            }
            this.cart.push(new SelectionCart(this.displayedResult, quantities));
        }

        this.updateSummary();
    }

    getCurrentLesson() {
        return this.cart.find(x => x.arcNr === this.displayedResult.arcNr &&
            x.lessonWebNr === this.displayedResult.lessonWebNr &&
            x.lessonDefNr === this.displayedResult.lessonDefNr &&
            x.lessonNr === this.displayedResult.lessonNr);
    }

    cleanUpCart() {
        let tmpCart = this.cart.filter(x => x.packages.filter(y => y.quantity > 0).length > 0);
        this.cart = tmpCart;
    }

    updateSummary() {
        this.cleanUpCart();
        if (this.cart.length === 0) {
            $(`[data-display-lp="summary"]`).css('display', 'none');
            return;
        }

        this.renderCartList();
        let quantity = 0;
        let price = 0;

        for (let cartItem of this.cart) {
            quantity += cartItem.packages.reduce((n, { quantity }) => n + quantity, 0);
            price += cartItem.packages.reduce((n, { quantity, price }) => n + (quantity * price), 0);
        }

        let unique = [...new Set(this.cart.map(x => x.from))];

        if (unique.length === 1) {
            $('[data-display-lp-summary="date"')
                .html(moment(unique[0], 'YYYY-MM-DD').format(this.initData.filterData.datePattern));
        } else {
            $('[data-display-lp-summary="date"')
                .html(this._i18nHelper.GetTranslation(Translations.Various));
        }

        $('[data-display-lp-summary="quantity"').html(this._i18nHelper.GetTranslation(Translations.SlotsN, quantity.toString()));
        $('[data-display-lp-summary="price"').html(this._priceHelper.GetPriceStringWithDecimalDivisorCalced(price).toString());
        $(`[data-display-lp="summary"]`).css('display', '');
    }

    updateCounter() {
        let quantity = this.counterArr.map(x => {
            return x.GetValue();
        }).reduce((n, curr) => n + curr, 0);

        const existingCart = this.getCurrentLesson();

        if (existingCart != null) {
            let existingQ = existingCart.packages.reduce((n, { quantity }) => n + quantity, 0);
            quantity += existingQ;
        }

        let maxQ = this.currentAvailableSlots - quantity;

        for (let pType of this.initData.filterData.pTypes) {

            this.counterArr[pType.id].updateMax(maxQ + this.counterArr[pType.id].GetValue());
        }
        $('[data-display-lp=available]').html(this._i18nHelper.GetTranslation(Translations.SlotsAvailable, (this.currentAvailableSlots - quantity).toString()));
    }

    updatePrice() {
        if (this.displayedResult?.packages == null) {
            return;
        }

        let total = 0;
        let totalQ = 0;

        for (let pack of this.displayedResult.packages) {
            const quantity = this.counterArr[pack.personTypeLink].GetValue();
            total += pack.price * quantity;
            totalQ += quantity;

            const listElem = $(`[data-display-lp-pType="${pack.personTypeLink}"]`);

            listElem.find('[data-display-lp-pType-price="single"]').html(
                this._priceHelper.GetPriceStringWithCurrencySymbol(pack.price /
                    this.localizationModule.getPriceToDecimalDivisor()));
            listElem.find('[data-display-lp-pType-price="total"]').html(
                this._priceHelper.GetPriceStringWithCurrencySymbol(pack.price * quantity /
                    this.localizationModule.getPriceToDecimalDivisor()));
        }

        $('[data-display-lp=price]').html(`${this._priceHelper.GetPriceStringWithCurrencySymbol(total / this.localizationModule.getPriceToDecimalDivisor())}`);
        $('[data-display-lp-add="quantity"]').toggleClass('d-none', totalQ === 0).html(`${this._i18nHelper.GetTranslation(Translations.SlotsN, totalQ.toString())}, `);
    }

    checkQuantity() {
        let totalQuantity = 0;
        for (let pType of this.initData.filterData.pTypes) {
            totalQuantity += this.counterArr[pType.id].GetValue();
        }
        $(`[data-trigger-lp="addSlot"]`).prop('disabled', totalQuantity === 0);
    }

    resetQuantity() {
        let availableSlots = this.currentAvailableSlots;
        for (let pType of this.initData.filterData.pTypes) {
            const pTypeQuantity =
                this.lessonFilter.currentSearch?.quantity?.find(x => x.id === pType.id)?.quantity ?? 0;
            const tmpQuantity = pTypeQuantity <= availableSlots ? pTypeQuantity : availableSlots;
            this.counterArr[pType.id].setValue(tmpQuantity);
            availableSlots -= tmpQuantity;
        }
        this.checkQuantity();
        this.updatePrice();
    }
}

interface ISelectionSlotResult {
    availableSlots: number;
    description: string;
    from: string;
    to: string;
    name: string;
    lessonLevelNr: number;
    locationId: number;
    arcNr: number,
    lessonWebNr: number,
    lessonDefNr: number,
    lessonNr: number,
    packages: {
        name: string;
        price: number;
        personTypeLink: number;
        productTriple: ProductTriple;
        packagePosNr: number;
    }[];
}


class SelectionCart {
    constructor(base: ISelectionSlotResult, quantity: { id: number; quantity: number; }[]) {
        this.arcNr = base.arcNr;
        this.lessonWebNr = base.lessonWebNr;
        this.lessonDefNr = base.lessonDefNr;
        this.lessonNr = base.lessonNr;
        this.name = base.name;
        this.from = base.from;
        this.to = base.to;
        this.availableSlots = base.availableSlots;
        this.lessonLevelNr = base.lessonLevelNr;
        this.locationId = base.locationId;
        let tmpPackages = base.packages.map((x) => {
            let tmpQuantity = quantity.find(y => y.id === x.personTypeLink)?.quantity ?? 0;
            return {
                ...x,
                ...{
                    quantity: Number(tmpQuantity)
                }
            }
        });
        this.packages = tmpPackages.filter(x => x.quantity !== 0);
    }

    arcNr: number;
    lessonWebNr: number;
    lessonDefNr: number;
    lessonNr: number;
    availableSlots: number;
    from: string;
    to: string;
    name: string;
    lessonLevelNr: number;
    locationId: number;
    packages: {
        name: string;
        price: number;
        personTypeLink: number;
        productTriple: ProductTriple;
        quantity: number;
        packagePosNr: number;
    }[];
}
